// extracted by mini-css-extract-plugin
export default {"myProfilePic":"Profilecard_myProfilePic__7O2g8","profileName":"Profilecard_profileName__Vc980"};